import { IonLabel } from "@ionic/react";
import { forwardRef } from "react";
import { cn } from "@/lib/style/cva.config";

export type FormFieldLabelProps = {
  required?: boolean;
  disabled?: boolean;
};

export const FormFieldLabel = forwardRef<
  HTMLIonLabelElement,
  React.ComponentProps<typeof IonLabel> & FormFieldLabelProps
>(function FormFieldLabel({ required, disabled, ...props }, ref) {
  return (
    <IonLabel
      ref={ref}
      {...props}
      className={cn(
        "font-semibold text-txt-primary",
        !disabled && required && "after:ms-0.5 after:text-error-120 after:content-['*']",
        props.className,
      )}
    />
  );
});
